
import chunk from 'lodash/chunk';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Tiles extends Vue {
  @Prop({
    default: 5,
  })
  public maxPerRow!: number;

  public render(createElement: any): any {
    if (this.$slots.default && this.$slots.default.length <= this.maxPerRow) {
      return this.renderAncestor(createElement, this.$slots.default);
    } else {
      return createElement(
        'div',
        { attrs: { class: 'is-tiles-wrapper' } },
        chunk(this.$slots.default, this.maxPerRow).map((group) => {
          return this.renderAncestor(createElement, group);
        }),
      );
    }
  }

  public renderAncestor(createElement: any, elements: any): any {
    return createElement(
      'div',
      { attrs: { class: 'tile is-ancestor' } },
      elements.map((element: any) => {
        return createElement('div', { attrs: { class: 'tile is-parent' } }, [
          element,
        ]);
      }),
    );
  }
}
